import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-past-meeting-dialog',
  templateUrl: './past-meeting-dialog.component.html',
  styleUrls: ['./past-meeting-dialog.component.css']
})
export class PastMeetingDialogComponent implements OnInit {
  meetingInfoData: any;

  constructor(@Inject(MAT_DIALOG_DATA) data:any) { 
    this.meetingInfoData = data;
 
  }

  ngOnInit(): void {
  }

}
